export default __webpack_public_path__ + "static/media/1_0064.647b0f49.webp";